'use strict';

function DateFormatter() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: ($scope, $element, $attrs, $ctrl) => {
      $ctrl.$formatters.unshift((value) => {
        return value ? moment(value, 'YYYY-MM-DD').format('DD.MM.YY') : null;
      });

      $ctrl.$parsers.unshift((value) => {
        return value ? moment(value, 'DD.MM.YY').format('YYYY-MM-DD') : null;
      });

      $ctrl.$validators.date = (modelValue) => {
        return $ctrl.$isEmpty(modelValue) || moment(modelValue, 'YYYY-MM-DD').isValid();
      };
    }
  };
}

angular
  .module('sr.formatters', [])
  .directive('dateFormatter', DateFormatter);
